import { render, staticRenderFns } from "./Geofence.vue?vue&type=template&id=19a99af8&scoped=true"
import script from "./Geofence.vue?vue&type=script&lang=js"
export * from "./Geofence.vue?vue&type=script&lang=js"
import style0 from "./Geofence.vue?vue&type=style&index=0&id=19a99af8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a99af8",
  null
  
)

export default component.exports